import { render, staticRenderFns } from "./TopStories.vue?vue&type=template&id=11515bcf&"
import script from "./TopStories.vue?vue&type=script&lang=ts&"
export * from "./TopStories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports